import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  Link,
} from "@chakra-ui/react";
import Header from "../components/Header";
import { pxToRem } from "../utils/editor.ts";

const RefundPolicy: React.FC = () => {
  return (
    <Box
      h="100%"
      padding={pxToRem(30)}
      pt={0}

    >
      {/* Decorative background elements */}
      <Box
        position="absolute"
        bottom="20%"
        right="10%"
        w={pxToRem(300)}
        h={pxToRem(300)}
        bg="rgba(29, 138, 255, 0.08)"
        borderRadius="full"
        filter={`blur(${pxToRem(80)})`}
        zIndex={0}
      />

      {/* Header with user menu */}
      <Header />

      <Box  pl={pxToRem(60)}  pt={pxToRem(20)} pb={pxToRem(40)} position="relative" zIndex={1} color={"#000"}>
        <VStack  align="flex-start">
          <Heading mb={0} as="h1" size="xl">
            Librum Refund & Cancellation Policy
          </Heading>
          <Text fontSize={'14px'} color="#000">
            Effective Date: August 18,2025
          </Text>
          <Box overflowY={"auto"} h={"65vh"}>
          <Text>
            We want you to have a positive experience with Librum. This Refund Policy explains when you may be eligible for a refund and how to request one.
          </Text>

          <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
            24-Hour First Purchase Guarantee
          </Heading>
          <Text>
            If you are unsatisfied with the Services after your first-ever purchase on your Librum account, you may request a 100% refund within 24 hours of payment.
          </Text>

          <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
            30-Day Pro-Rata Refund
          </Heading>
          <List styleType="decimal" pl={pxToRem(20)}>
            <ListItem>
              If you cancel within 30 days of purchase or renewal, you may receive a pro-rated refund for the unused portion of your subscription.
            </ListItem>
            <ListItem>
              Pro-rata refunds are calculated based on the remaining days in your subscription term, rounded down to the nearest full day.
            </ListItem>
          </List>

          <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
            After 30 Days
          </Heading>
          <List styleType="decimal" pl={pxToRem(20)}>
            <ListItem>
              No refunds are available for cancellations made more than 30 days after payment.
            </ListItem>
            <ListItem>
              Subscription renewals are non-refundable once processed, except that accidental renewals may be refunded if requested within 24 hours.
            </ListItem>
          </List>

          <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
            Non-Refundable Situations
          </Heading>
          <Text>
            Refunds are not available in the following cases:
          </Text>
          <List styleType="decimal" pl={pxToRem(20)}>
            <ListItem>
              Dissatisfaction with AI-generated content that is functioning as described.
            </ListItem>
            <ListItem>
              Failure to actively use the Services.
            </ListItem>
            <ListItem>
              Purchases made through third-party vendors (please contact them directly).
            </ListItem>
          </List>

          <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
            Refund Process
          </Heading>
          <Text>
            To request a refund:
          </Text>
          <List styleType="decimal" pl={pxToRem(20)}>
            <ListItem>
              Email <Link color="blue.500" href="mailto:support@doenba.ai">support@doenba.ai</Link> within the applicable refund window.
            </ListItem>
            <ListItem>
              Include your account email, order number, purchase date, and reason for the request.
            </ListItem>
            <ListItem>
              Refunds are typically processed within 5-10 business days, but may take up to 30 days depending on your payment provider. Refunds are always returned to the original payment method.
            </ListItem>
            <ListItem>
              Institutional & Managed Accounts
            </ListItem>
          </List>

          <Text>
            For accounts purchased via a school, company, or other organization:
          </Text>
          <List styleType="decimal" pl={pxToRem(20)}>
            <ListItem>
              Refund requests must be submitted through your designated account administrator.
            </ListItem>
            <ListItem>
              Eligible refunds may be issued on a pro-rated basis for unused subscription time.
            </ListItem>
          </List>

          <Heading mb={0} as="h2" size="md" pt={pxToRem(10)}>
            Legal Notice
          </Heading>
          <Text>
            This Refund Policy does not affect any rights you may have under applicable consumer protection laws, which may provide additional remedies.
          </Text>

          <Text pt={pxToRem(10)}>
            Contact: <Link color="blue.500" href="mailto:support@doenba.ai">support@doenba.ai</Link>
          </Text>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default RefundPolicy;